<app-view-dashboard-component>
  <section class="app-page-shell ui-showroom-page">
    <app-page-header-actions [eyebrow]="'Internal UI'"
      [title]="'UI Showroom'"
      [description]="'Reusable UI -komponenttien sisäinen testinäkymä eri käyttökonteksteissa.'"
      [useTranslate]="false"></app-page-header-actions>

    <app-data-surface class="ui-showroom-page-surface tw:grid tw:gap-app-4">
      <app-data-block>
        <div blockHeader>
          <h2>Shared tabs example</h2>
          <span>desktop + mobile-safe overflow</span>
        </div>

        <div class="ui-showroom-page-cards tw:grid tw:gap-app-4">
          <app-card>
            <app-section-header title="Desktop section tabs"
              description="Standardized shared section-tab pattern."></app-section-header>
            <app-segment-list [sub]="true"
              [segmentValue]="sectionTabsValue()"
              [segmentButtons]="sectionTabsButtons"
              (segmentChanged)="onSectionTabsChanged($event)"></app-segment-list>
          </app-card>

          <app-card>
            <app-section-header title="Mobile-safe long labels"
              description="Long labels stay in one row and scroll horizontally when needed."></app-section-header>
            <app-segment-list [sub]="true"
              [segmentValue]="mobileTabsValue()"
              [segmentButtons]="mobileTabsButtons"
              (segmentChanged)="onMobileTabsChanged($event)"></app-segment-list>
          </app-card>
        </div>
      </app-data-block>

      <app-data-block>
        <div blockHeader>
          <h2>Page content example</h2>
          <span>Page context</span>
        </div>

        <div class="ui-showroom-page-cards tw:grid tw:gap-app-4">
          <app-card>
            <app-section-header title="Shared KPI / metric cards"
              description="Desktop metric cards using one shared pattern and tone states."></app-section-header>
            <app-metric-cards [items]="metricCards"></app-metric-cards>
            <div class="ui-showroom-page-chip-row tw:flex tw:flex-wrap tw:gap-app-2">
              <app-status-chip label="On track"></app-status-chip>
              <app-status-chip label="Stable"
                tone="neutral"></app-status-chip>
              <app-status-chip label="Healthy"
                tone="success"></app-status-chip>
            </div>
          </app-card>

          <app-card>
            <app-section-header title="Compact metric cards"
              description="Same component in compact mode for denser surfaces."></app-section-header>
            <app-metric-cards [items]="compactMetricCards"
              [compact]="true"></app-metric-cards>
          </app-card>

          <app-card>
            <app-section-header title="Mobile-safe metric row"
              description="Horizontal scroll row for compact mobile KPI presentation."></app-section-header>
            <app-metric-cards [items]="mobileMetricCards"
              [compact]="true"
              [scrollRow]="true"></app-metric-cards>
          </app-card>

          <app-card>
            <app-section-header title="Section overview"
              description="Yksi peruskortti yleiseen sisältöosioon."></app-section-header>
            <p class="ui-showroom-page-body-text tw:text-app-text tw:leading-app-normal">
              Tämä on yksinkertainen body-esimerkki reusable sisältökortille sivukontekstissa.
            </p>
          </app-card>

          <app-card>
            <app-section-header title="Shared status chip tones"
              description="One consistent badge/chip primitive with normal and compact examples."></app-section-header>
            <div class="ui-showroom-page-chip-row tw:flex tw:flex-wrap tw:gap-app-2">
              <app-status-chip label="Default"></app-status-chip>
              <app-status-chip label="Neutral"
                tone="neutral"></app-status-chip>
              <app-status-chip label="Success"
                tone="success"></app-status-chip>
              <app-status-chip label="Warning"
                tone="warning"></app-status-chip>
              <app-status-chip label="Danger"
                tone="danger"></app-status-chip>
            </div>
            <div class="ui-showroom-page-chip-row tw:flex tw:flex-wrap tw:gap-app-2">
              <app-status-chip label="Compact"
                [compact]="true"></app-status-chip>
              <app-status-chip label="Compact neutral"
                tone="neutral"
                [compact]="true"></app-status-chip>
              <app-status-chip label="Compact success"
                tone="success"
                [compact]="true"></app-status-chip>
              <app-status-chip label="Compact warning"
                tone="warning"
                [compact]="true"></app-status-chip>
              <app-status-chip label="Compact danger"
                tone="danger"
                [compact]="true"></app-status-chip>
            </div>
          </app-card>

          <app-card>
            <app-section-header title="Shared page list"
              description="Simple list/item pattern page contextissa."></app-section-header>
            <div class="ui-showroom-page-list tw:grid tw:gap-app-3">
              @for (item of pageListItems; track item.title) {
                <app-list-item [title]="item.title"
                  [subtitle]="item.subtitle"
                  [trailing]="item.trailing"
                  [secondary]="item.secondary"></app-list-item>
              }
            </div>
          </app-card>

          <app-card>
            <app-section-header title="Long-label mobile-safe row"
              description="Long title truncates safely, trailing area stays stable."></app-section-header>
            <app-list-item title="Very long list title that should remain readable without breaking the row layout in narrow mobile screens"
              subtitle="Mobile-safe overflow behavior"
              secondary="Secondary helper line for additional context">
              <app-status-chip itemTrailing
                label="In review"
                tone="warning"
                [compact]="true"></app-status-chip>
            </app-list-item>
          </app-card>

          <app-card [dense]="true">
            <app-section-header title="Form section"
              description="Form stack wrapper asetteluun."></app-section-header>
            <app-form-stack>
              <app-form-field label="Name"
                helper="Reusable field wrapper with helper text.">
                <ion-item lines="inset">
                  <ion-input placeholder="Type value"></ion-input>
                </ion-item>
              </app-form-field>
              <app-form-field label="Code">
                <ion-item lines="inset">
                  <ion-input placeholder="Type code"></ion-input>
                </ion-item>
              </app-form-field>
            </app-form-stack>
          </app-card>

          <app-card [noPadding]="true">
            <div class="ui-showroom-page-card-section tw:p-app-4">
              <app-section-header title="Action area"
                description="Action row reusable layout."></app-section-header>
            </div>
            <div class="ui-showroom-page-card-section ui-showroom-page-card-section-top-border tw:p-app-4">
              <app-action-row align="between">
                <span class="ui-showroom-page-body-text tw:text-app-text tw:leading-app-normal">Section actions</span>
                <ion-button fill="clear"
                  color="medium">Cancel</ion-button>
                <ion-button color="light"
                  fill="solid">Save</ion-button>
              </app-action-row>
            </div>
          </app-card>
        </div>
      </app-data-block>

      <app-data-block>
        <div blockHeader>
          <h2>Small modal example</h2>
          <span>modal-default</span>
        </div>

        <div class="ui-showroom-page-actions tw:flex tw:items-center tw:gap-app-3">
          <ion-button color="light"
            fill="solid"
            (click)="openSmallModal()">
            Open small modal example
          </ion-button>
        </div>
      </app-data-block>

      <app-data-block>
        <div blockHeader>
          <h2>Workspace modal example (single)</h2>
          <span>workspace-modal + single</span>
        </div>

        <div class="ui-showroom-page-actions tw:flex tw:items-center tw:gap-app-3">
          <ion-button color="light"
            fill="solid"
            (click)="openWorkspaceModal('single')">
            Open workspace single
          </ion-button>
        </div>
      </app-data-block>

      <app-data-block>
        <div blockHeader>
          <h2>Workspace modal example (two-column)</h2>
          <span>workspace-modal + two-column</span>
        </div>

        <div class="ui-showroom-page-actions tw:flex tw:items-center tw:gap-app-3">
          <ion-button color="light"
            fill="solid"
            (click)="openWorkspaceModal('two-column')">
            Open workspace two-column
          </ion-button>
        </div>
      </app-data-block>

      <app-data-block>
        <div blockHeader>
          <h2>Workspace modal example (two-column-reverse)</h2>
          <span>workspace-modal + two-column-reverse</span>
        </div>

        <div class="ui-showroom-page-actions tw:flex tw:items-center tw:gap-app-3">
          <ion-button color="light"
            fill="solid"
            (click)="openWorkspaceModal('two-column-reverse')">
            Open workspace two-column-reverse
          </ion-button>
        </div>
      </app-data-block>
    </app-data-surface>
  </section>
</app-view-dashboard-component>

<ion-modal [isOpen]="smallModalOpen()"
  [cssClass]="smallModalCssClass"
  (didDismiss)="closeSmallModal()">
  <ng-template>
    <app-modal-shell [showFooter]="true"
      (dismiss)="closeSmallModal()">
      <div modalTitle>
        <h2 class="ui-showroom-page-modal-title tw:text-app-text">Small modal example</h2>
      </div>

      <div modalDescription>
        <p class="ui-showroom-page-modal-description tw:text-app-muted tw:leading-app-normal">Reusable content components small modal -kontekstissa.</p>
      </div>

      <div class="ui-showroom-page-modal-content">
        <app-card>
          <app-section-header title="Small modal form"
            description="app-card + app-section-header + app-form-stack + app-action-row"></app-section-header>
          <app-form-stack [dense]="true">
            <app-form-field label="Title"
              helper="Simple wrapped input field.">
              <ion-item lines="inset">
                <ion-input placeholder="Type title"></ion-input>
              </ion-item>
            </app-form-field>
            <app-form-field label="Description">
              <ion-item lines="inset">
                <ion-textarea placeholder="Type description"></ion-textarea>
              </ion-item>
            </app-form-field>
          </app-form-stack>
          <app-action-row>
            <ion-button fill="clear"
              color="medium">Reset</ion-button>
            <ion-button color="light"
              fill="solid">Apply</ion-button>
          </app-action-row>
        </app-card>

        <app-card [dense]="true">
          <app-section-header title="Compact modal list"
            description="Same shared list pattern in compact modal context."></app-section-header>
          <div class="ui-showroom-page-list tw:grid tw:gap-app-3">
            @for (item of modalListItems; track item.title) {
              <app-list-item [title]="item.title"
                [subtitle]="item.subtitle"
                [trailing]="item.trailing"
                [compact]="true"></app-list-item>
            }
          </div>
        </app-card>
      </div>

      <div modalFooter>
        <ion-button fill="clear"
          color="medium"
          (click)="closeSmallModal()">
          Cancel
        </ion-button>
        <ion-button color="light"
          fill="solid"
          (click)="closeSmallModal()">
          Save
        </ion-button>
      </div>
    </app-modal-shell>
  </ng-template>
</ion-modal>

<ion-modal [isOpen]="workspaceModalOpen()"
  [cssClass]="workspaceModalCssClass"
  (didDismiss)="closeWorkspaceModal()">
  <ng-template>
    <app-modal-shell [workspace]="true"
      [workspaceLayout]="workspaceLayout()"
      (dismiss)="closeWorkspaceModal()">
      <div modalTitle>
        <h2 class="ui-showroom-page-modal-title tw:text-app-text">Workspace modal example</h2>
      </div>

      <div modalDescription>
        <p class="ui-showroom-page-modal-description tw:text-app-muted tw:leading-app-normal">
          Layout: {{ workspaceLayoutLabel() }}
        </p>
      </div>

      <div modalMain
        class="ui-showroom-page-workspace-content">
        <app-card>
          <app-section-header title="Workspace main content"
            description="Yhtenäinen main-column sisältö kaikille workspace layout -vaihtoehdoille."></app-section-header>
          <app-form-stack>
            <app-form-field label="Subject"
              helper="Wrapped main-column workspace field.">
              <ion-item lines="inset">
                <ion-input placeholder="Type subject"></ion-input>
              </ion-item>
            </app-form-field>
            <app-form-field label="Reference">
              <ion-item lines="inset">
                <ion-input placeholder="Type reference"></ion-input>
              </ion-item>
            </app-form-field>
            <app-form-field label="Details">
              <ion-item lines="inset">
                <ion-textarea placeholder="Type details"></ion-textarea>
              </ion-item>
            </app-form-field>
          </app-form-stack>
        </app-card>
      </div>

      <aside modalAside
        class="ui-showroom-page-workspace-aside">
        <app-card>
          <app-section-header title="Workspace aside list"
            description="Shared list/item pattern in workspace side panel."></app-section-header>
          <div class="ui-showroom-page-list tw:grid tw:gap-app-3">
            @for (item of asideListItems; track item.title) {
              <app-list-item [title]="item.title"
                [trailing]="item.trailing"
                [secondary]="item.secondary"
                [compact]="true"></app-list-item>
            }
          </div>
        </app-card>
      </aside>

      <div modalFooter>
        <ion-button fill="clear"
          color="medium"
          (click)="closeWorkspaceModal()">
          Close
        </ion-button>
        <ion-button color="light"
          fill="solid"
          (click)="closeWorkspaceModal()">
          Save
        </ion-button>
      </div>
    </app-modal-shell>
  </ng-template>
</ion-modal>
